module.exports = __webpack_public_path__ + "static/img/3en.bf204c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/3en.png
// module id = cFDL
// module chunks = 0